<obg-m-dialog-layout
	[dialogId]="dialogId"
	[hideFooter]="true"
	[hideClose]="data.hideClose"
	[preserveDialogOnLogout]="data.preserveOnLogout"
	[attr.test-id]="data.testId || 'alert-' + dialogId"
	[attr.data-test-id]="data.testId || 'alert-' + dialogId"
	class="{{ data?.variant }}"
>
	<img
		*ngIf="data.brandLogo"
		class="obg-m-alert-brand-logo"
		[obgImageContent]="data.brandLogo.imageContent"
		[obgImageContentGroup]="data.brandLogo.imageContentGroup"
	/>
	<h1 *ngIf="data.title" [innerHTML]="data.title"></h1>
	<p *ngIf="data.message" [innerHTML]="data.message"></p>
	<div *ngIf="data.messageComponent" (click)="onElementClick($event.target)">
		<ng-template #message></ng-template>
	</div>
	<div class="obg-m-alert-footer">
		<mat-checkbox
			*ngIf="data.doNotShowAgainMessage"
			(change)="doNotShowAgain = $event.checked"
			test-id="alert-checkbox"
			data-test-id="alert-checkbox"
		>
			{{ "general.dont-show-again" | translate }}
		</mat-checkbox>
		<div
			class="obg-m-alert-buttons"
			*ngIf="data.buttons?.length"
			[class.obg-m-alert-vertical-buttons]="data.verticalButtons"
		>
			<ng-container *ngFor="let btn of data.buttons; trackBy: trackByButton" [ngSwitch]="btn.style">
				<button
					*ngSwitchCase="transparentButton"
					mat-button
					[color]="getButtonColor(btn)"
					(click)="btn.handler()"
					[attr.test-id]="'alert-button-' + btn.testIdSuffix"
					[attr.data-test-id]="'alert-button-' + btn.testIdSuffix"
					[attr.tabindex]="btn.tabindex"
				>
					{{ btn.text }}
				</button>
				<button
					*ngSwitchCase="strokedButton"
					mat-stroked-button
					[color]="getButtonColor(btn)"
					(click)="btn.handler()"
					[attr.test-id]="'alert-button-' + btn.testIdSuffix"
					[attr.data-test-id]="'alert-button-' + btn.testIdSuffix"
					[attr.tabindex]="btn.tabindex"
				>
					{{ btn.text }}
				</button>
				<button
					*ngSwitchDefault
					mat-flat-button
					[color]="getButtonColor(btn)"
					(click)="btn.handler()"
					[attr.test-id]="'alert-button-' + btn.testIdSuffix"
					[attr.data-test-id]="'alert-button-' + btn.testIdSuffix"
					[attr.tabindex]="btn.tabindex"
				>
					{{ btn.text }}
				</button>
			</ng-container>
		</div>
	</div>
</obg-m-dialog-layout>
